import { render } from "./RoadSignsView.vue?vue&type=template&id=45cad5c4"
import script from "./RoadSignsView.vue?vue&type=script&lang=js"
export * from "./RoadSignsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__